import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';
import { withRouter } from 'react-router';
import { loadProductsByCalculatedSales } from '../../../redux/modules/products';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';
import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import A from '../../shared/Anchor/Anchor';
import { primary_dark15, primary_light } from '../../shared/lib/colors';
import '../Categoria/Categoria.scss';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { ImageDispatcher } from '../../shared/ImageDispatcher/ImageDispatcher.js';

class Prodotti extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    // GA4 TRACK LIST
    if (this.props.hasGoogleAnalytics4Advanced) {
      this.ga4TrackItemsList();
    }

    // FKMX TRACK LIST
    if (this.props.hasFarmakomMetrics) {
      this.fkmxTrackItemsList();
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      // GA4 TRACK LIST
      if (this.props.hasGoogleAnalytics4Advanced) {
        this.ga4TrackItemsList();
      }

      // FKMX TRACK LIST
      if (this.props.hasFarmakomMetrics) {
        this.fkmxTrackItemsList();
      }
    }
    // if (oldProps.location.pathname !== this.props.location.pathname) {
    //   this.props.loadProductsByCalculatedSales(this.props.location.query);p
    // }
  }

  ga4TrackItemsList = () => {
    const { products } = this.props;

    const ga4ListInfo = {
      id: `most_sold_products`,
      name: `prodotti > più venduti`,
    };

    ga4ViewItemList(products, ga4ListInfo);
  };

  fkmxTrackItemsList = () => {
    const { products } = this.props;

    const fkmxListInfo = {
      id: `most_sold_products`,
      name: `prodotti > più venduti`,
    };

    fkmxViewItemList(products, fkmxListInfo);
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts(isMobile) {
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const ga4ListInfo = {
      id: `prodotti_più-venduti`,
      name: `prodotti > più venduti`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );

    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div className="col-sm-6 col-lg-4 col-xl-3" key={product.id}>
              <ProductThumbnail
                secondaryColor={this.props.secondaryColor}
                primaryColor={this.props.primaryColor}
                productsCarouselVersion={productsConfiguration.moduleVersion}
                product={product}
                list="Più venduti"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const ga4ListInfo = {
      id: `prodotti_più-venduti`,
      name: `prodotti > più venduti`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );

    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  secondaryColor={this.props.secondaryColor}
                  primaryColor={this.props.primaryColor}
                  productsCarouselVersion={productsConfiguration.moduleVersion}
                  key={product.id}
                  product={product}
                  list="Più venduti"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                  lazy={index >= 4}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const {
      location,
      pagination,
      products,
      loading,
      siteName,
      siteUrl,
      logoImage,
      primaryColor,
      linkDrugsAuthorizedSite,
      linkDrugsAuthorizedSiteVet,
    } = this.props;

    const showDrugsAuthorization = products.some(
      product =>
        product.taxCreditType === 'DRUG' ||
        product.taxCreditType === 'HOMEOPATHY'
    );

    const showDrugsVetAuthorization = products.some(
      product => product.taxCreditType === 'VETERINARY_DRUG'
    );

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`Prodotti più venduti`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita - prodotti più venduti`,
            },
            {
              name: 'keywords',
              content: `${siteName}, ecommerce, farmacia, ${siteName}`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita - prodotti più venduti`,
            },

            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online - prodotti più venduti`,
            },
            { property: 'og:image', content: logoImage },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/prodotti`,
            },
          ]}
        />

        <div className="container">
          <LeftFilters
            location={location}
            sort={location.query.sort || 'sales'}
          />
          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb page="prodotti" bestSeller={true} />

              {products.length > 0 && pagination.totalPages > 1 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                display: 'flex',
                alignItems: 'center',
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
              }}
            >
              <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 0 }}>
                Prodotti più venduti
              </h1>
              {loading && (
                <span className="pull-right">
                  <FaSpinner className="pulse" />
                </span>
              )}
              {showDrugsAuthorization && !!linkDrugsAuthorizedSite && (
                <div>
                  <a
                    className="store-authorized-link"
                    href={linkDrugsAuthorizedSite}
                    target="_blank"
                    aria-label="Link all'autorizzazione ministeriale della farmacia"
                  >
                    <ImageDispatcher
                      src="/static/images/logo_farmacia_autorizzata.png"
                      style={{ width: 60 }}
                      alt="Logo farmacia autorizzata"
                    />
                  </a>
                </div>
              )}
              {showDrugsVetAuthorization && !!linkDrugsAuthorizedSiteVet && (
                <div>
                  <a
                    className="store-authorized-link"
                    href={linkDrugsAuthorizedSiteVet}
                    target="_blank"
                    aria-label="Link all'autorizzazione ministeriale della farmacia"
                  >
                    <ImageDispatcher
                      src="/static/images/logo_farmacia_autorizzata_vet.png"
                      style={{ width: 60 }}
                      alt="Logo farmacia autorizzata"
                    />
                  </a>
                </div>
              )}
            </div>

            {!loading && products.length > 0 && (
              <div>
                <div className="row">
                  {this.renderProducts(this.props.isMobile)}
                </div>

                {pagination.totalPages > 1 && (
                  <Pager
                    location={location}
                    page={location.query.page || 1}
                    totalPages={pagination.totalPages}
                    sort={location.query.sort || 'sales'}
                    primaryColor={primaryColor}
                    isNew
                  />
                )}
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>
                  Nessun prodotto da visualizzare tra i prodotti più venduti in
                  questo momento
                </p>
                <p>Torna a trovarci presto!</p>
              </div>
            )}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    pagination: state.products.pagination,
    products: state.products.data,
    loading: state.products.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
    linkDrugsAuthorizedSite:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSite,
    linkDrugsAuthorizedSiteVet:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSiteVet,
  };
}

export default withRouter(
  connect(mapStateToProps)(
    connectDataFetchers(Prodotti, [loadProductsByCalculatedSales])
  )
);
